import dayjs from "./dayjs-local";

export const defaultFormatWithOffset = "DD MMM YYYY HH:mm:ss ([UTC]Z)";
export const defaultFormat = "DD MMM YYYY HH:mm:ss";

export const toLocalTimeFromUTCWithOffset = (date: number | string) => {
  return dayjs.utc(date).local().format(defaultFormatWithOffset);
};
export const toLocalTimeFromUTC = (date: number | string) => {
  return dayjs.utc(date).local().format(defaultFormat);
};
